import type { ButtonProps } from "../Button";
import type { DataTableDensity } from "./types";

export const getActionButtonSize = (
  density?: DataTableDensity
): ButtonProps["size"] => {
  switch (density) {
    case "relaxed":
      return "small";
    case "compact":
      return "xx-small";
    case "normal":
    default:
      return "x-small";
  }
};
